import { fuego } from '@nandorojo/swr-firestore';
import { IcommentItem } from '@typings/common/comment.interface';
import { getTagUserIdList } from '@utils/getTagUserIdList';
import {
  addGroupNotification,
  addMasterGroupNotification,
  addNotification,
} from './add-notification';
import {
  NOTI_TYPE,
  NOTI_TYPE_VALUE,
} from '@typings/notification/notificationType';
import { ItimelineItem } from '@typings/pages/timeline.interface';
import { IguestbookItem } from '@typings/guestbook/guestbook.interface';
import { ImemoItem } from '@typings/pages/memoItem.interface';
import { IThreadItem } from '@typings/threads/threads.interface';
import { IpostingItem } from '@typings/posting/posting.interface';
import { Inotification } from '@typings/notification/notification.interface';

type mentionDataProps = {
  data: any;
};

export async function mentionUserNotificaton({ data }: mentionDataProps) {
  // 맨션된 유저들에게 보냄
  const mentionUserIdList = getTagUserIdList(data.contents);
  console.log({ mentionUserIdList });

  if (mentionUserIdList.length >= 1) {
    await addGroupNotification({
      receiverIdList: mentionUserIdList,
      data: {
        type: NOTI_TYPE.TAGGED,
        receiver: data.boardAuthorUid || '',
        ...data,
      },
    });
  }
}


type Props = {
  data: IcommentItem | IguestbookItem | ImemoItem | IpostingItem | ItimelineItem | IThreadItem;
  collectionPath: string;
  sendToMasters?: boolean;
  notiType?: NOTI_TYPE_VALUE;
  guestbook?: boolean;
  sendToBoth?: boolean; // 양쪽 모두에게 보내는 알림인지
};

// 멘션한 유저와 마스터 그룹에게 모두 보내는 완전판 알림 함수
export async function updateUserNotification({
  data,
  collectionPath,
  sendToMasters,
  notiType,
  guestbook,
  sendToBoth,
}: Props) {
  // --------------------------------------
  // 알림 추가
  // --------------------------------------

  // boardAuthorUid와 contents 프로퍼티가 없는 타입이 있으므로 안전하게 처리
  const boardAuthorUid = (data as any).boardAuthorUid || (data as any).authorUid;
  const contents = (data as any).contents || '';
  const boardId = (data as any).boardId || null;

  if (boardAuthorUid || guestbook) {
    const notificationData: Inotification = {
      type: notiType || NOTI_TYPE.COMMENT,
      contents,
      createdAt: new Date(),
      sender: data.authorUid!,
      collectionPath,
      is_seen: false,
      postId: boardId,
      receiver: boardAuthorUid || null,
    };

    // 맨션된 유저들에게 보냄
    mentionUserNotificaton({ data: notificationData });

    // 마스터에게 알림 추가 (옵션, addMasterGroupNotification 내부에서 Firestore 설정 체크)
    if (sendToMasters) {
      await addMasterGroupNotification({ data: notificationData });
    }
    // 댓글 작성 시 게시글 작성자에게 알림
    // 게시글 작성자와 댓글 작성자가 다를 때만 알림
    if (boardAuthorUid != data.authorUid) {
      if (sendToBoth) {
        await addNotification({
          data: notificationData,
          receiver: notificationData.sender,
        });
      }
      return addNotification({
        data: notificationData,
        receiver: notificationData.receiver,
      });
    }
  }
  // --------------------------------------
  // 알림 추가 end
  // --------------------------------------
}
